import { cn } from '@seen/ui'
import { IconNotes } from '@tabler/icons-react'

export function IconNotepad({ className }: { className?: string }) {
  return <IconNotes className={cn('size-4 shrink-0', className)} />
}
